import { applyFilter, getPossibleFilterValues } from "../../services/api";
import { errorHandling } from "..";
import { mapGetters, mapMutations } from "vuex";

export const filterMixin = {
  mixins: [errorHandling],
  methods: {
    async applyFilters(numberOfItems, skipItems) {
      const response = await applyFilter(
        this.constructFilter(numberOfItems, skipItems)
      );
      if (response.status === 201) {
        return response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    async setSelectOptions() {
      for (let select of this.selects) {
        let options = await this.getSelectOptions(
          select.key,
          this.constructFilterQuery()
        );
        if (options === undefined) options = [];
        this.addSelectOptions({ key: select.key, options });
      }
    },
    async getSelectOptions(key, query) {
      const response = await getPossibleFilterValues(key, query);
      if (response.status === 200) {
        return response.data;
      } else {
        this.handleHttpError(response);
      }
    },

    constructFilter(numberOfItems, skipItems) {
      return {
        ...{
          searchString: this.getSearchString,
          type: this.getType,
          category: this.category,
          sex: this.getSex,
          numberOfItems: numberOfItems || 20,
          skipItems: skipItems || null,
          onSale: this.getOnSale,
          sustainable: this.getSustainable,
          store: this.getStore
        },
        ...this.selects.reduce((acc, curr) => {
          return { ...acc, ...{ [curr.key]: curr.model } };
        }, {})
      };
    },
    constructFilterQuery() {
      let queryObject = {
        ...this.selects.reduce((acc, curr) => {
          const keysRegEx = /type|sizes|store|brand|color/;
          if (keysRegEx.test(curr.key) && curr.model) {
            if (curr.key === "brand" || curr.key === "store") {
              if (curr.model.length === 0) {
                return { ...acc };
              }
            }
            return { ...acc, ...{ [curr.key]: curr.model } };
          }
          return { ...acc };
        }, {})
      };
      if (this.getType) {
        queryObject = { ...queryObject, ...{ type: this.getType } };
      }
      if (this.category) {
        queryObject = { ...queryObject, ...{ category: this.category } };
      }
      if (this.getOnSale) {
        queryObject = { ...queryObject, ...{ onSale: this.getOnSale } };
      }
      if (this.getStore) {
        queryObject = { ...queryObject, ...{ store: this.getStore } };
      }
      if (this.getSustainable) {
        queryObject = {
          ...queryObject,
          ...{ sustainable: this.getSustainable }
        };
      }
      if (this.getSex) {
        queryObject = { ...queryObject, ...{ sex: this.getSex } };
      }
      if (this.getSearchString) {
        queryObject = {
          ...queryObject,
          ...{ searchString: this.getSearchString }
        };
      }
      return queryObject;
    },
    ...mapMutations({
      addSelectOptions: "filters/addSelectOptions"
    })
  },
  computed: {
    ...mapGetters({
      selects: "filters/getSelectsWithTypeSelect",
      getSearchString: "filters/getSearchString",
      getSex: "filters/getSex",
      getSustainable: "filters/getSustainable",
      category: "filters/getCategory",
      getOnSale: "filters/onSale",
      getType: "filters/getType",
      getStore: "filters/getStore"
    })
  }
};
